import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getuniversalPlans } from "../../../services/operations/authAPI";
import Loader from "../../loader/Loader";
import NavLogo from '../../../assets/logo-transparent-png.png';
import heroImage from '../../../assets/home-page.png'
import featureImage2 from '../../../assets/Minimalist Website Launch Computer Mockup Instagram Post-2 1.svg'
import featureImage1 from '../../../assets/mockrocket-capture.png'
import '../../../styles/homeStyle.css'
import MainSection from "./MainSection";
import AboutHired from "./About1800Hired";
import HomeNav from "./NavBar";
import Footer from "./Footer";
import Recommended from '../../../assets/vecteezy_recommended-with-thumb-up-sign_36579847.jpg'
import img1 from '../../../assets/Component 5.png'
import img2 from '../../../assets/Component 6.png'
import img3 from '../../../assets/Component 7.png'
import img4 from '../../../assets/Component 8.png'
import img5 from '../../../assets/Component 9.png'
import img6 from '../../../assets/Component 10.png'
import locationImg from '../../../assets/distance.svg'
import skillImg from '../../../assets/history_edu.svg'
import companyImg from '../../../assets/source_environment.svg'
import expImg from '../../../assets/experience.svg'
import keywordImg from '../../../assets/key_vertical.svg'
import millionImg from '../../../assets/80M.svg'
import RecruiterImg from '../../../assets/RecruiterImg.svg'
import CountryImg from '../../../assets/countruesImg.svg'
import upparHover from "../../../assets/upparHover.svg"
import lowerHover from "../../../assets/lowerHover.svg"
import emailImg from "../../../assets/contact_mail.svg"
import countryHoverUpp from "../../../assets/countryuppar.svg"
import countryHoverLow from "../../../assets/countryLower.svg"
import connectWithout from "../../../assets/connect_without_contact.svg"
import ProfileImg from "../../../assets/profileImg.svg"
import curve from "../../../assets/curve.svg"
import backgroundImg from '../../../assets/background.svg'
import Subscribe from "./Subscribe";
import { getThreeJobs } from "../../../services/operations/JobPostAPI";


const LandingPage = () => {
  const [plans, setPlans] = useState([]);
  const [coords, setCoords] = useState(null);
  const token = useSelector((state) => state.auth.token);
  const loading = useSelector((state) => state.auth.loading);
  const user = useSelector((state) => state.profile.user);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const baseUrl = window.location.origin

  const userRole = user?.roles[0]?.name;

  const getPlans = async () => {
    const response = await dispatch(getThreeJobs());
    setPlans(response?.data?.data[0])
  };

  function getCurrentLocation(callback) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const coords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          callback(coords);
        },
        error => {
          console.error("Geolocation error:", error.message);
          callback(null);
        }
      );
    } else {
      console.error("Geolocation not supported");
      callback(null);
    }
  }


  useEffect(() => {
    getPlans();
    getCurrentLocation(location => {
      if (location) {
        setCoords(location)

      } else {
        setCoords({})

      }
    });
  }, []);



  return (
    <>
      <HomeNav text={false}/>
      <div className="page-wrapper">
        <MainSection coords={coords} />
        <section className='second-section'>
          <div className='second-section-container'>
            <div className='second-section-uppar-part'>
              <p>See who’s hiring with <span style={{ color: "#3574D6", fontWeight: "700" }}>1800hired</span></p>
              <p className='second-section-subheading'>See who all are onboard with us!</p>
            </div>
            <div className='second-section-lower'>
              <img src={img1} alt='' className='second-section-images' />
              <img src={img2} alt='' className='second-section-images' />
              <img src={img3} alt='' className='second-section-images' />
              <img src={img4} alt='' className='second-section-images' />
              <img src={img5} alt='' className='second-section-images' />
              <img src={img6} alt='' className='second-section-images' />
            </div>
          </div>
        </section>
      </div>
      <section className="feature-section" id='whatwedo'>
        <div className="feature-container">
          {/* Row 1 */}
          <div className="feature-row" >
            <div className="feature-text">
              <p className="feature-heading">Why Choose <span style={{ color: "rgba(45, 118, 253, 1)", fontWeight: "700" }}>1800Hired</span><br />
                Talent based Hiring <span style={{ fontWeight: "700" }}>Around the globe</span></p>
              <ul className="feature-list" role="list">
                <li className="feature-list-item">
                  <svg className="feature-icon" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="feature-item-text">
                    <span style={{ color: 'rgba(45, 118, 253, 1)' }}>AI-Driven Insights</span>: Our advanced algorithms deliver the most relevant matches, saving you time and effort
                  </span>
                </li>
                <li className="feature-list-item">
                  <svg className="feature-icon" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="feature-item-text">
                    <span style={{ color: 'rgba(45, 118, 253, 1)' }}>Enhanced Productivity</span>: Streamline the hiring process by focusing on the right candidates without manual guesswork
                  </span>
                </li>
                <li className="feature-list-item">
                  <svg className="feature-icon" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="feature-item-text">
                    <span style={{ color: 'rgba(45, 118, 253, 1)' }}>Global Reach</span>: Access resumes from around the world, helping you connect with talent across borders
                  </span>
                </li>
              </ul>
            </div>
            <div className="feature-image-wrapper">
              <img
                className="feature-image"
                src={featureImage1}
                alt="dashboard feature image"
              />
            </div>
          </div>
          {/* Row 2 */}

        </div>
      </section>
      <section className="feature-section-second" id="whatwedo">
        <div className="feature-container-second">
          <div className="feature-row" id='whyus' style={{ backgroundColor: "white", maxWidth: "1600px" }}>
            <img
              className="feature-image"
              src={featureImage2}
              alt="feature image 2"
            />
            <div className="feature-text">
              <p className="feature-heading">We Offer<br />
                Smart Resume <span style={{ fontWeight: "700" }}>Management</span></p>
              <ul className="feature-list" role="list">
                <li className="feature-list-item">
                  <img src={locationImg} className="feature-icon" />
                  <span className="feature-item-text">
                    <span style={{ color: 'rgba(45, 118, 253, 1)' }}>Location</span>: Narrow down candidates by geography to focus on your target market
                  </span>
                </li>
                <li className="feature-list-item">
                  <img src={skillImg} className="feature-icon" />
                  <span className="feature-item-text">
                    <span style={{ color: 'rgba(45, 118, 253, 1)' }}>Skills</span>: Pinpoint the exact expertise you’re looking for
                  </span>
                </li>
                <li className="feature-list-item">
                  <img src={companyImg} className="feature-icon" />
                  <span className="feature-item-text">
                    <span style={{ color: 'rgba(45, 118, 253, 1)' }}>Companies & Industry</span>: Filter by previous employers or industries to match your criteria.
                  </span>
                </li>
                <li className="feature-list-item">
                  <img src={expImg} className="feature-icon" />
                  <span className="feature-item-text">
                    <span style={{ color: 'rgba(45, 118, 253, 1)' }}>Experience</span>: Find candidates with the ideal years of experience for your needs
                  </span>
                </li>
                <li className="feature-list-item">
                  <img src={keywordImg} className="feature-icon" />
                  <span className="feature-item-text">
                    <span style={{ color: 'rgba(45, 118, 253, 1)' }}>Keyword</span>: Customize searches using specific terms to uncover hidden talent gems
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="trusted-section">
        <div className="trusted-container">
          <div className="trusted-left">
            <p className="trusted-subtitle">Trusted Worldwide</p>
            <h2 className="trusted-title">Number of <span style={{ fontWeight: "600" }}>recruiters, candidates and businesses</span></h2>
          </div>

          <div className="trusted-left-desc">
            <div className="trusted-description">
              <p>
                1800Hired.com offers AI-powered matching to find top talent fast, boosts productivity by streamlining hiring,
                and connects you to a global talent pool. It’s your smart hiring partner—transforming how you discover and engage
                exceptional candidates worldwide
              </p>
            </div>
            <div className="trusted-grid">
              <div className="trusted-item">
                <img src={countryHoverUpp} className="hover-lower" />
                <img src={countryHoverLow} className="hover-upper" />
                <img src={connectWithout} className="email-icon" />
                <p className="hover-title">20+ Countries</p>
                <p className="hover-desc">Have been with us for hiring candidate</p>
              </div>
              <div className="trusted-item">
                <img src={upparHover} className="hover-upper" />
                <img src={lowerHover} className="hover-lower" />
                <img src={emailImg} className="email-icon" />
                <p className="hover-title">5k+ Recruiters</p>
                <p className="hover-desc">Trusted globally for talent sourcing</p>
              </div>
               <div className="trusted-item">
  <img src={countryHoverUpp} className="hover-lower" />
  <img src={countryHoverLow} className="hover-upper" />
  <img src={ProfileImg} className="email-icon" />
  <p className="hover-title">80M+ Profiles </p>
  <p className="hover-desc">Has been created on 1800hired.com</p>
</div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="pricing-section" id="pricing">
        <div className="pricing-container">
          <div className="pricing-header">
            <h2>Designed for business teams like yours</h2>
            <p>
              Here at 1800Hired.com, we focus on markets where technology, innovation, and capital can unlock long-term value and drive economic growth.
            </p>
          </div>
          <div className="pricing-cards">
            <div className="pricing-card">
              <h3>Basic Recruiter License</h3>
              <p>Access Resumes based on
                Earned/& Daily Credits</p>
              <div className="price" >
                <span style={{ fontSize: "1.5rem" }}>Free for limited time</span>
                <span></span>
              </div>
              <div className="price-first">
                <span>$14.99</span>
                <span>/month</span>
              </div>
              <hr style={{ marginBottom: "1rem",border:"1px solid #F3F4F6"  }} />
              <ul className="pricing-list">
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>View/Download global
                    resumes on credit*</span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Max storage - 248MB (for
                    your resumes)</span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>No need to maintain Excel
                    sheet<sup>**</sup></span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>User personal email
                    address<sup>**</sup></span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>AI search on your/global
                    resume database</span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Make unlimited notes and
                    refer anytime in future**</span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>No yearly Contract, Month
                    to Month</span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Cancel Anytime</span>
                </li>
              </ul>
              <a href="/register">Get started</a>
            </div>
            <div className="pricing-card" style={{position:"relative"}}>
            <img src={Recommended} alt="recommended" className="badge" />
              <h3>Premium Recruiter License</h3>
              <p>Unlimited access to resumes</p>
              <div className="price" style={{ margin: "2.75rem 0rem 1rem 0rem" }}>
                <span style={{ fontSize: "1.5rem" }}>${plans?.amount}</span>
                <span>/month</span>
              </div>
              <div className="price-first">
                <span>${plans?.demoprice}</span>
                <span>for first month</span>
              </div>
              <hr style={{ marginTop: "1rem",border:"1px solid #F3F4F6" }} />
              <div className="price-first">
                <span></span>
                <span></span>
              </div>
              <ul className="pricing-list">
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>View/Download
                    unlimited global
                    resumes</span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Max storage –
                    Unlimited</span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>No need to maintain Excel
                    sheet<sup>**</sup></span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>User personal email
                    address<sup>**</sup></span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>AI search on your/global
                    resume database</span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Make unlimited notes and
                    refer anytime in future<sup>**</sup></span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>No yearly Contract, Month
                    to Month</span>
                </li>
                <li>
                  <svg
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Cancel Anytime</span>
                </li>
              </ul>
              <a href="/register">Get started</a>
            </div>
            <div className="pricing-card">
              <h3>Enterprise License</h3>
              <div className="price" style={{ margin: "0rem 0rem 0rem" }}>
                <span style={{ fontSize: "1.5rem" }}>Coming Soon</span>
              </div>
              <hr style={{ marginBottom: "28rem",border:"1px solid #F3F4F6" }} />
            </div>
          </div>
          <div className="pricing-desc" style={{ padding:"4rem 0rem 0rem 1.25rem"}}>
            <p><b style={{color:"black"}}>*</b>Earn Credits: Recruiters, upload and manage your resumes to earn rewards! Get 10 credits for every 10
              uploads.</p>
            <p><b style={{color:"black"}}>**</b>Effortless Organization: Forget folders and spreadsheets—make unlimited notes and access past
              discussions anytime.</p>
            <p><b style={{color:"black"}}>**</b>Flexible Sign-Up: No corporate email required! Use your personal email to register hassle-free.</p>
          </div>
        </div>
      </section> */}
      <AboutHired />
      <Subscribe />
      <Footer />
    </>
  );
};

export default LandingPage;